<script lang="ts">
    import { onMount } from 'svelte'
    import Router from '$classes/Router'
    import { setMainRouterParams } from '$lib/stores/route'
    import { partnerBoot } from '$lib/guards'
    import { buildRoutes, type LayoutKind } from './routes'

    let GlobalLayout: any = null
    let UserLayout: any = null
    let BackofficeLayout: any = null
    let AuthLayout: any = null
    let Page: any = null
    let layout: LayoutKind = 'plain'

    const setPage = (C: unknown) => (Page = C)
    const setLayout = (l: LayoutKind) => (layout = l)

    const parse = (activeRoute: any, next: () => void) => {
        setMainRouterParams(activeRoute)
        Page = null
        next()
    }

    onMount(async () => {
        GlobalLayout = (await import('$pages/layouts/GlobalLayout.svelte')).default
        UserLayout = (await import('$pages/layouts/UserLayout.svelte')).default
        BackofficeLayout = (await import('$pages/layouts/BackofficeLayout.svelte')).default
        AuthLayout = (await import('$pages/layouts/AuthLayout.svelte')).default

        const routes = buildRoutes({ setPage, setLayout })
        new Router({ routes, globalPreFunctions: [parse, partnerBoot] })
    })
</script>

{#if GlobalLayout}
    <svelte:component this={GlobalLayout}>
        {#if layout === 'user' && UserLayout}
            <svelte:component this={UserLayout}>
                {#if Page}<svelte:component this={Page} />{/if}
            </svelte:component>
        {:else if layout === 'backoffice' && BackofficeLayout}
            <svelte:component this={BackofficeLayout}>
                {#if Page}<svelte:component this={Page} />{/if}
            </svelte:component>
        {:else if layout === 'auth' && AuthLayout}
            <svelte:component this={AuthLayout}>
                {#if Page}<svelte:component this={Page} />{/if}
            </svelte:component>
        {:else}
            {#if Page}<svelte:component this={Page} />{/if}
        {/if}
    </svelte:component>
{/if}
